import { AuditTable } from "../../components/AuditTable";
import { ErrorNotice, Loading, Panel } from "../../components/ui";
import { developerApi } from "../../lib/api";
import { useQuery } from "../../lib/query";
import { useClient } from "../../lib/session";
import type { GameTabProps } from "./Game";

export function GameActivity({ game, env }: GameTabProps) {
  const api = developerApi(useClient());
  const q = useQuery(`dev:audit:${game.id}:${env}`, () => api.auditLogs(game.id, { environment: env, limit: 100 }));
  return (
    <Panel title="Activity" sub="Configuration changes, key events and money movements in this environment, newest first." flush>
      <ErrorNotice error={q.error} onRetry={q.reload} />
      {q.loading && !q.data && <Loading />}
      {q.data && <AuditTable rows={q.data.data} showTenant={false} />}
    </Panel>
  );
}
